import type { ThemeConfig } from 'antd';

/**
 * Menteem – colors.css ile uyumlu (lacivert #1e40af); daha kurumsal spacing ve radius.
 */
export const menteemTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1e40af',
    colorLink: '#1d4ed8',
    colorSuccess: '#059669',
    colorWarning: '#d97706',
    colorError: '#dc2626',
    colorInfo: '#0284c7',
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 8,
    fontFamily:
      "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    lineHeight: 1.55,
    controlHeight: 40,
    controlHeightLG: 44,
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#e2e8f0',
    colorText: '#0f172a',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#64748b',
    boxShadow:
      '0 1px 2px 0 rgba(15, 23, 42, 0.04), 0 1px 3px 0 rgba(15, 23, 42, 0.03)',
    boxShadowSecondary:
      '0 4px 12px rgba(15, 23, 42, 0.06), 0 2px 4px rgba(15, 23, 42, 0.04)',
  },
  components: {
    Layout: {
      bodyBg: '#f8fafc',
      headerBg: '#ffffff',
      headerHeight: 64,
    },
    Card: {
      paddingLG: 24,
      boxShadowTertiary: '0 1px 2px 0 rgba(15, 23, 42, 0.04)',
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#0f172a',
      rowHoverBg: '#f1f5f9',
      borderColor: '#e2e8f0',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
    },
    Tabs: {
      inkBarColor: '#1e40af',
      titleFontSize: 15,
      horizontalMargin: '0 0 16px 0',
    },
    Modal: {
      borderRadiusLG: 14,
      boxShadow: '0 12px 40px rgba(15, 23, 42, 0.1)',
    },
    Dropdown: {
      paddingBlock: 6,
    },
    Menu: {
      itemBorderRadius: 10,
      iconSize: 18,
    },
  },
};
